import { FC } from 'react';
import type { AccountPermissions } from '@/types';

// 账号类型配置
export const ACCOUNT_PERMISSIONS_CONFIG = {
  claude: {
    name: 'Claude',
    description: '支持Claude全模型，专业AI编程助手',
    color: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: '🤖'
  },
  all: {
    name: '全模型',
    description: '支持所有可用模型，功能最全面',
    color: 'bg-purple-50 border-purple-200 text-purple-800',
    icon: '🎭'
  }
} as const;

interface AccountTypeSelectorProps {
  selectedType: AccountPermissions;
  onTypeChange: (type: AccountPermissions) => void;
  disabled?: boolean;
  showLabel?: boolean;
  className?: string;
}

export const AccountTypeSelector: FC<AccountTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
  disabled = false,
  showLabel = true,
  className = ''
}) => {
  return (
    <div className={className}>
      {showLabel && (
        <label className="block text-sm font-medium text-gray-700 mb-3">
          账号类型 *
        </label>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {Object.entries(ACCOUNT_PERMISSIONS_CONFIG).map(([permission, config]) => (
          <div
            key={permission}
            className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
              selectedType === permission
                ? config.color
                : 'border-gray-200 hover:border-gray-300'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !disabled && onTypeChange(permission as AccountPermissions)}
          >
            <div className="flex items-center">
              <input
                type="radio"
                name="permissions"
                value={permission}
                checked={selectedType === permission}
                onChange={() => !disabled && onTypeChange(permission as AccountPermissions)}
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300"
                disabled={disabled}
              />
              <div className="ml-3">
                <div className="flex items-center">
                  <span className="mr-2">{config.icon}</span>
                  <span className="text-sm font-medium text-gray-900">
                    {config.name}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  {config.description}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};